import Image from 'next/image';

import { BrandHandMarkTwoLinesVariant2 } from '../../../../../design-system/components/illustration/BrandHandMarkTwoLinesVariant2';
import { Typography } from '../../../../../design-system/components/typography/Typography';
import { EditoBlockSliceType } from '../../../../../domains/Prismic/BrandPages/BrandPagesDocument';
import { EvaneosPrismicRichText } from '../../../../../domains/Prismic/EvaneosPrismicRichText';

import style from './EditoBlockSlice.module.css';

export type EditoBlockSliceProps = EditoBlockSliceType;

export function EditoBlockSlice({
    backgroundPicture,
    foregroundPicture,
    title,
    topText,
    bottomText,
}: EditoBlockSliceProps) {
    return (
        <div className={style.wrapper}>
            {backgroundPicture?.url ? (
                <picture>
                    <source media="(min-width: 768px)" srcSet={backgroundPicture.desktop.url} />
                    <Image
                        className={style.backgroundPictureImg}
                        alt={backgroundPicture.alt}
                        src={backgroundPicture.url}
                        fill
                        priority
                        sizes={`(min-width: 768px) ${backgroundPicture.width / 2}px, ${backgroundPicture.desktop.width / 2}px`}
                    />
                </picture>
            ) : null}
            <div className="layout-with-centered-content">
                <div className="main-container">
                    <div className={style.content}>
                        {topText ? (
                            <Typography as="div" scale="primary-body-bold">
                                <EvaneosPrismicRichText field={topText} />
                            </Typography>
                        ) : null}
                        {foregroundPicture?.url ? (
                            <picture>
                                <source
                                    media="(min-width: 768px)"
                                    srcSet={foregroundPicture.desktop.url}
                                />
                                <div className={style.foregroundPicture}>
                                    <Image
                                        className={style.foregroundPictureImg}
                                        alt={foregroundPicture.alt}
                                        src={foregroundPicture.url}
                                        fill
                                        priority
                                        sizes={`(min-width: 768px) ${foregroundPicture.width / 2}px, ${foregroundPicture.desktop.width / 2}px`}
                                    />
                                </div>
                            </picture>
                        ) : null}
                        {bottomText ? (
                            <Typography as="div" scale="primary-body-bold">
                                <EvaneosPrismicRichText field={bottomText} />
                            </Typography>
                        ) : null}
                    </div>
                    <div className={style.title}>
                        <Typography as="h2" scale="primary-xl-extra-bold">
                            <div className={style.titleRichText}>
                                <EvaneosPrismicRichText field={title} components={{}} />
                            </div>
                            <BrandHandMarkTwoLinesVariant2 color="var(--color-secondary-main)" />
                        </Typography>
                    </div>
                </div>
            </div>
        </div>
    );
}
